import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useFirstSeenFilter } from './useFirstSeenFilter';

export const FirstSeenFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, firstSeenOptions } = useFirstSeenFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ daysSinceAdded: value || firstSeenOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="daysSinceAdded"
          label="First seen"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={firstSeenOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

FirstSeenFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

FirstSeenFilter.defaultProps = {
  value: null,
};
